<script>
import {
  required
} from "vuelidate/lib/validators";

export default {
  props: {
    videoDetail: {
      type: Object,
    },
    packageType: {
      type: String,
      default: ''
    }
  },
  mounted() {
    if (this.videoDetail) {
      Object.assign(this.form, this.videoDetail)
    } 
  },
  validations: {
    form: {
      impressions: { required },
      videoPrice: { required }
    }
  },
  data() {
    return {
      submitted: false,
      form: {
        impressions: '',
        videoPrice: '',
      }
    }
  },
  methods: {
    submitVideoModal(cancel) {
      this.submitted = true;

      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.$emit('submit', { data: this.form, cancel })
      }
    }
  }
}
</script>

<template>
  <b-modal id="video-modal" centered size="lg">
    <template v-slot:modal-header="{ close }">
      <div class="text-center w-100 position-relative">
        <b-button size="sm" variant="link" @click="close()" class="position-absolute top-0 right-0">
          <i class="bx bx-x font-size-24 text-dark"></i>
        </b-button>
        <div class="text-center">
          <h4>Video Channel</h4>
        </div>
      </div>
    </template>
    <div>
      <div class="row">
        <div class="col-6">
          <b-form-group label="Guaranteed Impressions" label-for="impressions">
            <p>Number of impressions this campaign will deliver</p>
            <b-form-input id="impressions" name="impressions" type="number" placeholder="Enter impressions amount" v-model="form.impressions" :class="{ 'is-invalid': submitted && $v.form.impressions.$error }" />
            <div v-if="submitted && $v.form.impressions.$error" class="invalid-feedback">
              <span v-if="!$v.form.impressions.required">This value is required.</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Video Cost ex GST" label-for="cost">
            <p>Total cost of the video ads for this package</p>
            <b-form-input id="cost" name="cost" type="number" placeholder="Enter total package cost" v-model="form.videoPrice" :class="{ 'is-invalid': submitted && $v.form.videoPrice.$error }" />
            <div v-if="submitted && $v.form.videoPrice.$error" class="invalid-feedback">
              <span v-if="!$v.form.videoPrice.required">This value is required.</span>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ cancel }">
      <div>
        <b-button
          variant="primary"
          @click="() => submitVideoModal(cancel)"
        >
          Save and Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>